import { KatButton, KatInput } from '@amzn/katal-react';
import { FC } from 'react';
import styles from './SearchBar.module.css';

const BUTTON_LABELS = {
  SEARCH: 'Search',
  SEARCHING: 'Searching...',
  CLEAR: 'Clear',
} as const;

const DEFAULT_MAX_LENGTH = 100 as const;

export interface SearchBarProps {
  label: string;
  placeholder: string;
  query: string;
  isSearching: boolean;
  disabled: boolean;
  maxLength?: number;
  onInputChange: (event: KatInput.ChangeEvent) => void;
  onKeyDown: (event: KatInput.KeydownEvent) => void;
  onSearchClick: () => void;
  onClearSearch: () => void;
}

export const SearchBar: FC<SearchBarProps> = ({
  label,
  placeholder,
  query,
  isSearching,
  disabled,
  maxLength = DEFAULT_MAX_LENGTH,
  onInputChange,
  onKeyDown,
  onSearchClick,
  onClearSearch,
}) => (
  <div className={styles.inputGroup}>
    <KatInput
      label={label}
      placeholder={placeholder}
      value={query}
      onInput={onInputChange}
      onKeydown={onKeyDown}
      disabled={disabled}
      maxlength={maxLength}
      data-testid="search-input"
      className={styles.searchBox}
    />
    <KatButton
      variant="primary"
      label={isSearching ? BUTTON_LABELS.SEARCHING : BUTTON_LABELS.SEARCH}
      onClick={onSearchClick}
      disabled={disabled || !query.trim() || isSearching}
      data-testid="search-button"
    />
    {query && (
      <KatButton
        variant="warning"
        label={BUTTON_LABELS.CLEAR}
        onClick={onClearSearch}
        disabled={disabled || isSearching}
        data-testid="clear-button"
      />
    )}
  </div>
);
